function initCollectionCarousel(container) {
  if (!container) return;
  const nextButton = container.querySelector(".slider-button--next");
  const prevButton = container.querySelector(".slider-button--prev");
  const slider = container.querySelector(".slider");
  if (!nextButton || !slider) {
    return;
  }
  const jumpAmount = 3;
  nextButton.addEventListener("click", function (event) {
    event.preventDefault();
    const firstSlide = slider.querySelector(".slider__slide");
    if (!firstSlide) return;
    const slideStyle = window.getComputedStyle(firstSlide);
    const slideMargin =
      parseFloat(slideStyle.marginLeft) + parseFloat(slideStyle.marginRight);
    const slideWidth = firstSlide.getBoundingClientRect().width + slideMargin;
    const scrollAmount = slideWidth * jumpAmount;
    slider.scrollBy({
      left: scrollAmount,
      behavior: "smooth",
    });
  });
  prevButton.addEventListener("click", function (event) {
    event.preventDefault();

    const firstSlide = slider.querySelector(".slider__slide");
    if (!firstSlide) return;

    const slideStyle = window.getComputedStyle(firstSlide);
    const slideMargin =
      parseFloat(slideStyle.marginLeft) + parseFloat(slideStyle.marginRight);
    const slideWidth = firstSlide.getBoundingClientRect().width + slideMargin;

    const scrollAmount = slideWidth * jumpAmount;

    slider.scrollBy({
      left: -scrollAmount,
      behavior: "smooth",
    });
  });
}
